// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-4jx","colBig":"styles_colBig__2yYVU","colSmall":"styles_colSmall__1mO_t"};